import { service } from '@/utils/request'
const preApi = process.env.VUE_APP_ENV === 'development' ? '/dev' : ''
class texture {
  // 获取素材信息
  static getTextureInfo (params) {
    return service.get(`${preApi}/pccloud/cloud_package_info`, { params })
  }
  // 提交或者保存 素材
  static submitTextureEdit (params) {
    return service.post(`${preApi}/pccloud/cloud_package_edit`, params)
  }
  // 获取素材列表
  static getTextureList (params) {
    return service.get(`${preApi}/pccloud/cloud_package_list`, { params })
  }
  // 回退素材
  static revokeAudit (params = {}) {
    return service.post(`${preApi}/pccloud/revoke_audit`, params)
  }
  // 删除素材
  static delTexture (params) {
    return service.post(`${preApi}/pccloud/cloud_package_del`, params)
  }
  // 提交或者保存 人物素材
  static submitCharacterEdit (params) {
    return service.post(`/api/charactermaterial/material_edit`, params)
  }
  // 获取人物素材信息
  static getCharacterInfo (params) {
    return service.get(`/api/charactermaterial/material_info`, { params })
  }
  // 删除人物素材
  static delCharacter (params) {
    return service.post(`/api/charactermaterial/material_del`, params)
  }
  // 获取人物素材列表
  static getCharacterList (params) {
    return service.get(`/api/charactermaterial/material_list`, { params })
  }
}

export default texture
